import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRadioButtonUnchecked = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: 1,
		width: 17,
		height: 17,
		rx: 8.5,
		stroke: "#CED0DA"
	})
});
const ForwardRef = forwardRef(SvgRadioButtonUnchecked);
export default ForwardRef;
